module.exports = __webpack_public_path__ + "img/pdf.8ea3518d.png";